import { Helmet } from 'react-helmet-async';
import { jsx as _jsx } from "react/jsx-runtime";
export var Head = function Head(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Helmet, {
    "data-element": "Helmet",
    "data-component": "Head",
    "data-source-file": "index.tsx",
    children: children
  });
};